<button type="button" class="time-indicator" [class]="timeBadge().className"
  (click)="toggleTheme()"
  [title]="isDark() ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'"
  [attr.aria-label]="isDark() ? 'Activar tema claro' : 'Activar tema oscuro'"
  [attr.aria-pressed]="isDark()">
  <span class="time-indicator__icon">
    <i [class]="timeBadge().icon"></i>
  </span>
  <span class="time-indicator__label">{{ timeBadge().label }}</span>
</button>
